<template>
  <!-- eslint-disable -->
<v-container fluid>
<v-slide-y-transition mode="out-in">
  <div>
    <v-speed-dial v-model="fab" right top fixed direction="bottom" transition="slide-y-reverse-transition">
      <template v-slot:activator>
        <v-btn class="refresh-btn" v-model="fab" color="blue darken-2" dark fab>
          <v-icon v-if="fab">close</v-icon>
          <v-icon v-else>account_circle</v-icon>
        </v-btn>
      </template>
      <v-btn fab dark small class="add-user-btn" color="indigo" @click="add()">
        <v-icon>add</v-icon>
      </v-btn>
      <v-btn fab class="refresh-users-btn" dark small color="red" @click="loadUsers()">
        <v-icon>refresh</v-icon>
      </v-btn>
    </v-speed-dial>
    <v-layout row wrap class="ma-0 pa-0">
      <v-flex class="ma-0 pa-0">
        <v-text-field class="user-filter" slot="search" prepend-icon="search" :append-icon="search == null || search.length === 0 ? '' : 'clear'" @click:append="() => (search = null)" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-flex>
      <v-flex class="ma-0 pa-0">
        <v-select content-class="role-filter-list" class="role-filter-select" :items="roles" v-model="selectedRoleIds" multiple prepend-icon="filter_list" item-text="Name" item-value="RoleId" label="Filter by Role" single-line :append-icon="(selectedRoleIds == null || selectedRoleIds.length === 0) ? '' : 'clear'" @click:append="() => (selectedRoleIds = [])"></v-select>
      </v-flex>
    </v-layout>
    <v-data-table :mobile-breakpoint="0" class="users-data-table" :items-per-page.sync="rowsPerPage" :footer-props="{'items-per-page-options': [50,100,200]}" :items="filteredUsers" item-key="UserName" :headers="headers" :loading="loading">
      <template slot="no-data">
        <div v-if="loading" class="text-xs-center users-loading">
          Loading ParcelShield Users. . .
        </div>
        <div v-else class="text-xs-center no-users">
          No Users.
        </div>
      </template>
      <template v-slot:item="{ item }">
        <tr class="user-row" v-on:mouseenter="userHover(item, true)" v-on:mouseleave="userHover(item, false)" @click="edit(item)">
          <td>
            <v-list-item-action avatar style="float: left">
              <v-avatar class="user-avatar" :class="getColor(item.ClientId)" v-if="!item.hover">
              <span class="white--text headline">{{item.UserName.match(/\b(\w)/g)[0].toUpperCase()}}</span>
              </v-avatar>
              <div v-else class="edit-icon" style="position: relative; top: 5px; left: 15px;">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" @click="edit(item)" small>mode_edit</v-icon>
                  </template>
                  <span>Edit</span>
                </v-tooltip>
              </div>
            </v-list-item-action>
            <div style="padding: 20px 0 20px 75px;"><b>{{ item.UserName }}</b></div>
          </td>
          <td>
            {{ item.Email }}
          </td>
          <td class="hidden-sm-and-down">
            {{ item.PhoneNumber }}
          </td>
          <td class="hidden-sm-and-down">
            {{item.LastName}}<span v-if="item.FirstName && item.LastName">, </span>{{item.FirstName}}
          </td>
        </tr>
      </template>
    </v-data-table>
    <parcel-shield-user-dialog></parcel-shield-user-dialog>
  </div>
  </v-slide-y-transition>
  </v-container>
<!-- eslint-enable -->
</template>
<script>
import parcelShieldUsersModule, {
  PARCEL_SHIELD_USERS_NAMESPACE
} from "./store/parcelShieldUserStore";
import { mapGetters } from "vuex";
import ParcelShieldUserDialog from "./ParcelShieldUserDialog";
import UserMixin from "@/mixins/UserMixin.js";
export default {
  name: "ParcelShieldUsers",
  components: {
    "parcel-shield-user-dialog": ParcelShieldUserDialog
  },
  mixins: [UserMixin],
  data() {
    return {
      headers: [
        { text: "User Name", sortable: true, align: "left", value: "UserName" },
        {
          text: "Email",
          sortable: true,
          align: "left",
          value: "Email"
        },
        {
          text: "Phone",
          sortable: false,
          align: "left",
          class: "hidden-sm-and-down"
        },
        {
          text: "Name",
          sortable: true,
          align: "left",
          value: "LastName",
          class: "hidden-sm-and-down"
        }
      ],
      rowsPerPage: 100,
      selectedRoleIds: []
    };
  },
  computed: {
    ...mapGetters(PARCEL_SHIELD_USERS_NAMESPACE, [
      "users",
      "loading",
      "roles",
      "clients"
    ]),
    filteredUsers() {
      if (this.search) {
        if (this.selectedRoleIds.length > 0) {
          return this.users
            .filter(x =>
              x.UserName.toLowerCase().includes(this.search.toLowerCase())
            )
            .filter(
              x =>
                x.UserRoles &&
                x.UserRoles.filter(e => this.selectedRoleIds.includes(e.RoleId))
                  .length > 0
            );
        } else {
          return this.users.filter(x =>
            x.UserName.toLowerCase().includes(this.search.toLowerCase())
          );
        }
      } else if (this.selectedRoleIds.length > 0) {
        return this.users.filter(
          x =>
            x.UserRoles &&
            x.UserRoles.filter(e => this.selectedRoleIds.includes(e.RoleId))
              .length > 0
        );
      }
      return this.users;
    }
  },
  created: /* istanbul ignore next */ function() {
    this.USER_MIXIN_NAMESPACE = PARCEL_SHIELD_USERS_NAMESPACE;
    this.$registerVuexModule(
      PARCEL_SHIELD_USERS_NAMESPACE,
      parcelShieldUsersModule
    );
    this.$isInRole([this.$roleDefs.ADMIN, this.$roleDefs.USERS_ADMIN]).then(
      res => {
        if (res) {
          this.loadUsers();
          this.loadClients();
          this.loadRoles();
        } else this.$goHome();
      }
    );
  },
  methods: {
    loadRoles() {
      return this.$store.dispatch(
        `${PARCEL_SHIELD_USERS_NAMESPACE}/loadUserRoles`
      );
    }
  }
};
</script>
